var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-social-instagram"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 6.89,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.17cc529cab32df1f7c5271f35faa9a96.svg";
export { ForwardRef as ReactComponent };